// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { IonButton, IonCol, IonGrid, IonRow } from "@ionic/react"
import { ConsoleSectionContainer } from "../../components"
import ConsoleSectionPage from "../ConsoleSectionPage"
import { KnowledgeBaseLink } from "../../../../lib"
import { useLocales } from "react-localized"


const ProductMasterDataPage: React.FC = () => {
  const {gettext} = useLocales()
  return (
    <ConsoleSectionPage>
      <ConsoleSectionContainer
        title={gettext("Product manager")}
        ready={true}
      >
        <IonGrid style={{paddingTop: "var(--section-padding)"}}>
          <IonRow>
            <IonCol>
              <KnowledgeBaseLink doc="test/lorem1">
                <IonButton>Open the KB</IonButton>
              </KnowledgeBaseLink>
            </IonCol>
          </IonRow>
        </IonGrid>
      </ConsoleSectionContainer>
    </ConsoleSectionPage>
  )
}


export { ProductMasterDataPage }